export default __webpack_public_path__ + "static/media/1940.6c1ffba3.png";